import { isEmpty } from 'lodash-es';
import { m as sanitizeHTML } from './bxf-utils-3908c3c5.js';

/**
 * Function computes width of given string
 * @param value {string}
 * @param multiplier {number}
 */
function computeContentWidth(value, multiplier = 1, size) {
    if (!isEmpty(value) && document.body) {
        const el = document.createElement('div');
        document.body.appendChild(el);
        el.style.display = 'table';
        el.style.fontSize = size === 'small' ? `${13 / 16}rem` : '1rem';
        el.style.whiteSpace = 'nowrap';
        el.innerHTML = sanitizeHTML(value);
        const width = Math.ceil(el.clientWidth * multiplier);
        document.body.removeChild(el);
        return `${width}px`;
    }
    return '';
}

export { computeContentWidth as c };
